import { Outlet } from "react-router";
import { Sidebar, SidebarMobileTrigger } from "./Sidebar";

export function AppShell() {
  return (
    <div className="flex min-h-screen bg-slate-50 dark:bg-[#0f1114]">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <SidebarMobileTrigger />
        <main className="min-w-0 flex-1 p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
